// hooks/useOptionsONT.ts
import { useEffect, useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { useFetchUbicacionProductosEnabled } from "@/shared/actions/erp";
import { CategoryProducCodeEnum } from "@/shared/interfaces/erp/inventario";
import { ONTOption, OrdenTrabajo } from "@/shared/interfaces";
import { mapearONTOptions } from "../utils/mapearONTOptions";

interface UseOptionsONTParams {
  ordentrabajo: OrdenTrabajo;
  valueTab: number;
  form: UseFormReturn<any>;
}

export function useOptionsONT({ ordentrabajo, valueTab, form }: UseOptionsONTParams) {
  const { data: dataUbicacionProd, isLoading: isloadingUbProducto } =
    useFetchUbicacionProductosEnabled({
      enabled: valueTab === 4 && Boolean(ordentrabajo?.flota_data?.ubicacion),
      params: {
        page_size: 1000,
        page: 1,
        categoria_producto: CategoryProducCodeEnum.EQUIPOS,
        ubicacion: ordentrabajo?.flota_data?.ubicacion,
      },
    });

  const optionsONT = useMemo<ONTOption[]>(
    () => mapearONTOptions(dataUbicacionProd?.data?.data),
    [dataUbicacionProd],
  );

  // Cuando cambian las opciones de ONT disponibles, se resetea el campo
  // `ont_a_utilizar` del form para que refleje el equipo ya asignado.
  useEffect(() => {
    if (!form.getValues().ont_a_utilizar) return;

    form.reset({
      ...form.getValues(),
      ont_a_utilizar: form.getValues()?.equipos_utilizados?.[0] || {},
    });
  }, [optionsONT]);

  return { optionsONT, isloadingUbProducto };
}